module.exports = __webpack_public_path__ + "static/media/24_blanco.0f772f94.svg";